module.exports = __webpack_public_path__ + "static/media/Accommodation-lrg.d86b8cfa.svg";